import { distanceBetweenPoints } from './measurement-utils';
/**
 * Returns the center coordinates of the touches in a touch event.
 */
export const getCenterPointOfTouchEvent = (event) => {
    const touches = Array.from(event.touches);
    const touchSum = touches.reduce((acc, touch) => ({
        x: acc.x + touch.pageX,
        y: acc.y + touch.pageY
    }), { x: 0, y: 0 });
    return {
        x: touchSum.x / touches.length,
        y: touchSum.y / touches.length
    };
};
/**
 * Returns the average distance from the center of touches in a touch event.
 */
export const getAverageTouchDistanceFromTouchCenter = (event) => {
    const touchCenter = getCenterPointOfTouchEvent(event);
    const touches = Array.from(event.touches);
    return (touches.reduce((acc, touch) => acc +
        distanceBetweenPoints({
            x: touch.pageX,
            y: touch.pageY
        }, touchCenter), 0) / touches.length);
};
/**
 * Returns the scale of a pinch event relative to the initial pinch distance.
 */
export const getPinchScale = (event, initialPinchDistance) => {
    const pinchDistance = getAverageTouchDistanceFromTouchCenter(event);
    return pinchDistance / initialPinchDistance;
};
